var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 71,
    viewBox: "0 0 90 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1821 1L5.22933 5.45193L4.93256 7.15849L1 10.7942L1.29675 12.7234L7.38107 16.9528L10.2006 17.2496L15.3204 28.3052L21.5531 32.7572L22.8145 36.1703L28.0084 40.2513L27.118 42.1062L35.2057 49.7487L37.0607 58.1332L40.7706 62.14L42.6998 69.6341L46.113 70.2277V66.5919L48.1163 66.9629L49.2293 67.7049L49.8971 66.7403L49.0067 65.9241L47.7453 65.8499L46.0388 59.172L48.1905 60.0624L48.0421 61.8432L49.3035 63.7724L50.1197 62.14L51.0843 65.1079L53.3845 64.5885L53.8297 61.9916L51.3811 61.6206L51.1585 60.5076L50.0455 58.6526L50.6391 57.688L56.2782 61.1012L58.2074 59.7656L55.7588 57.2428L58.801 56.0557L58.2816 57.5396L59.4688 59.2462L64.4401 56.7234L64.1433 54.6459L66.2951 54.2749L69.7824 51.7521L69.2631 50.4907L71.0438 49.0067L74.3086 49.6003L74.3828 47.8938L75.3474 47.226L73.5666 45.742L77.2024 46.0388L74.828 42.9224L77.4991 41.8094L83.7319 33.6475L89 30.9764L68.2985 9.75546L48.5615 9.08767L45.6678 3.44854L43.2192 4.26473L42.774 1.96456L21.1821 1Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSc);
export default __webpack_public_path__ + "static/media/SC.2ccad07ab487fd2be6ecf2ddb0021626.svg";
export { ForwardRef as ReactComponent };